import React, { PureComponent } from 'react';
import { Container, Row, Col, Card, CardBody, Progress } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import {check, uploadFileGeologiaSitiosArqueologicos } from "../../Services/FileService";
import PropTypes from 'prop-types';
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';
import DropFiles from './components/DropFiles';

let notificationTC = null;

class UploadShapeGeologiesSitiosArqueologicos extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      inProcess: false,
      processingStatus: 0,
      data: []
    };
    check();

    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.process = this.process.bind(this);
  }

  onFormSubmit(e){
    if(e.files != null && e.files != undefined){
      this.setState({ inProcess: true });
      this.process(e.files, 0, (e.files.length-1));
    }
  }
  
  process(files, index, length){
    let formData = new FormData();
    formData.append('file', files[index]);

    uploadFileGeologiaSitiosArqueologicos(formData).then(response => {
      let processingStatus = ((index+1) /  (length+1)) * 100;
      this.setState({ processingStatus: processingStatus.toFixed(2) });
      if(index === length){
        this.show('success', this.props.t('forms.uploadSuccess'));
        setTimeout(
          () => window.location.reload(true), 
          1000
        );
      }else{
        this.process(files, index+1, length);
      }
    });
  }

  componentDidMount() {
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  render() {
    const { t } = this.props;
    const { processingStatus } = this.state;

    let view = [];
    if(this.state.inProcess){
        view.push(
          <Col key="col1" md={12} lg={12}>
            <Card key="card1">
              <CardBody key="cardbody1">
                <div key="div1" className="progress-wrap progress-wrap--big">
                  <Progress key="progress1" animated value={processingStatus} />
                </div>
              </CardBody>
            </Card>
          </Col>
       );
    } 
    view.push(<DropFiles key="dropfiles1" onSubmit={this.onFormSubmit} />);

    return (
      <div className="containerInside__wrap">
        <Container>
          <Row>
            <Col md={10}>
              <h3 className="page-title">{t('forms.shapes_form.title')}</h3>
              <h3 className="page-subhead subhead">{t('forms.shapes_form.descriptionCS')}</h3>
            </Col>
          </Row>

          <Row>
            {view}
          </Row>
        </Container>
      </div>
      
    );
  }
}

export default withTranslation('common')(UploadShapeGeologiesSitiosArqueologicos);